<style scoped lang="stylus" rel="stylesheet/stylus">
.title
  width 100%
  line-height 40px
  text-align center
  font-size 16px
  color #333
  background #ccc
</style>

<template>
	<div>
		<nav-bar />
		<div class="title" flex="main:center cross:center">插槽内容</div>
		<NavigationLink1 url="www.baidu.com"></NavigationLink1>
		<NavigationLink1 url="www.baidu.com">跳转百度</NavigationLink1>

		<div class="title">编辑作用域</div>
		<NavigationLink2 url="www.baidu.com">
			<div>Logged in as {{ user1.name }}</div>
			<!--<div>不能访问 navigation-link 的作用域。url: {{url}}</div>-->
		</NavigationLink2>

		<div class="title">具名插槽</div>
		<base-layout>
			这是正文内容
			<!--<template v-slot:default>这是正文</template>-->
			<template v-slot:header>这是头部</template>
			<template v-slot:footer>这是尾部</template>
		</base-layout>

		<div class="title">作用域插槽-插槽prop</div>
		<CurrentUser>
			<template v-slot:default="defaultSlotProps">
				{{ defaultSlotProps.user11.firstName }}{{ defaultSlotProps.user11.lastName }}
			</template>
			<template v-slot:cat="catSlotProps">{{ catSlotProps.cat11.age }}</template>
		</CurrentUser>
		<!--<CurrentUser v-slot:default="slotProps">-->
		<CurrentUser v-slot="slotProps">
			{{ slotProps.user11.firstName }}{{ slotProps.user11.lastName }}
		</CurrentUser>
		<CurrentUser> </CurrentUser>

		<div class="title">作用域插槽-解构插槽prop</div>
		<CurrentUser>
			<template v-slot:default="{ user11 }">
				{{ user11.firstName }}
			</template>
		</CurrentUser>
		<CurrentUser v-slot="{ user11 }">
			{{ user11.firstName }}
		</CurrentUser>

		<div class="title">示例-todo-list组件</div>
		<TodoList></TodoList>
		<TodoList>
			<template v-slot:todo="{ todo }"> {{ todo.text }}{{ todo.time }} </template>
		</TodoList>
		<input type="text" placeholder="请输入" />
		<home-btn />
	</div>
</template>

<script>
import NavigationLink1 from './slot1'
import NavigationLink2 from './slot2'
import BaseLayout from './slot3'
import CurrentUser from './slot4'
import TodoList from './todoList'
import homeBtn from '../../components/navigation/home-btn'
import navBar from '../../components/navigation/nav-bar'
export default {
	name: 'slot',
	components: {
		NavigationLink1,
		NavigationLink2,
		BaseLayout,
		CurrentUser,
		TodoList,
		homeBtn,
		navBar
	},
	data() {
		return {
			user1: {
				name: 'zl'
			}
		}
	}
}
</script>
